"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paths = void 0;
var path_1 = __importDefault(require("path"));
var filewhitelist = "________________________________";
var internal = "internal";
var Paths = /** @class */ (function () {
    function Paths(filepath) {
        var fp = (filepath === null || filepath === void 0 ? void 0 : filepath.endsWith(path_1.default.sep)) ? "" + filepath + filewhitelist : filepath !== null && filepath !== void 0 ? filepath : "";
        var fileparsed = path_1.default.parse(fp);
        this.file = {
            base: fileparsed.base === filewhitelist ? "" : fileparsed.base,
            ext: fileparsed.ext,
            name: fileparsed.name === filewhitelist ? "" : fileparsed.name,
        };
        this.absolutePath = fileparsed.root !== "";
        if (fileparsed.dir === "")
            this.dir = [internal];
        else
            this.dir = path_1.default
                .normalize(fileparsed.dir)
                .split(path_1.default.sep)
                .filter(function (v) { return v !== "" && v !== ".."; });
    }
    Object.defineProperty(Paths.prototype, "isFileExist", {
        get: function () {
            return this.file.base !== "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Paths.prototype, "isDirectoryExist", {
        get: function () {
            return this.dir.length >= 1 && !this.dir.includes(internal);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Paths.prototype, "absolute", {
        get: function () {
            return this.absolutePath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Paths.prototype, "dirdeep", {
        get: function () {
            return this.dir.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Paths.prototype, "filename", {
        get: function () {
            return this.file.base;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * first will return first number of directory
     *
     * @example
     *    first(0) of /a/b/c/d.txt -> d.txt
     *    first(2) of /a/b/c/d.txt -> b/c/d.txt
     * @param num
     */
    Paths.prototype.first = function (num) {
        if (num <= 0)
            return this.filename;
        else
            return this.dir
                .slice(this.dir.length - num, this.dir.length)
                .concat(this.filename)
                .join(path_1.default.sep);
    };
    /**
     * get directory name at num
     *
     * @example
     *    at(2)  of /a/b/c/d/e/f.txt -> d
     *    at(1)  of /a/b/c/d/e/f.txt -> e
     *    at(0)  of /a/b/c/d/e/f.txt -> f.txt
     *    at(-1) of /a/b/c/d/e/f.txt -> a
     * @param num num
     */
    Paths.prototype.at = function (num) {
        if (num >= this.dir.length || num < 0)
            return this.dir[0];
        else if (num === 0)
            return this.filename;
        else
            return this.dir[this.dir.length - num];
    };
    /**
     * after will get path after regex
     *
     *
     * @example
     *    after(/b/, 1) of /a/b/c/d/e.txt -> c
     *    after(/d/, 0) of /a/b/c/d/e.txt -> d
     *    after(/b/, 1, 1) of /a/b/c/d/e.txt -> c/d
     *    after(/d/, 0, 5) of /a/b/c/d/e.txt -> d
     * @param regex directory regex name
     * @param num number of directory after regex
     * @param size zero mean 1 directory only
     */
    Paths.prototype.after = function (regex, num, size) {
        if (size === void 0) { size = 0; }
        var n = num < 0 ? 0 : num;
        var index = this.dir.findIndex(function (v) { return regex.test(v); });
        var targetdir = index < 0 ? this.dir[n] : this.dir[index + n];
        if (size <= 0)
            return targetdir;
        else {
            var arr = [targetdir, this.after(regex, n + 1, size - 1)];
            return arr.filter(function (v) { return v !== undefined && v !== ""; }).join(path_1.default.sep);
        }
    };
    /**
     * check is input regex include in path
     * @param regex directory or file name
     */
    Paths.prototype.includes = function (regex) {
        if (regex.test(this.filename))
            return true;
        else if (this.dir.some(function (d) { return regex.test(d); }))
            return true;
        else
            return false;
    };
    return Paths;
}());
exports.Paths = Paths;
//# sourceMappingURL=path.js.map